module.exports = __webpack_public_path__ + "static/media/m_eyebrowshape_softangled_shadow.3da4b90a.png";